import { useQuery } from '@tanstack/react-query';

import { User } from '@e-origin/shared';

import { MILLISECONDS_IN_SECOND, SECONDS_IN_MINUTE, STALE_TIME_USE_DECLARANT_MIN } from '@constants';
import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useUser = () => {
  return useQuery({
    queryKey: ['user-profile'],
    staleTime: MILLISECONDS_IN_SECOND * SECONDS_IN_MINUTE * STALE_TIME_USE_DECLARANT_MIN, // 10 min
    queryFn: async (): Promise<User> => {
      try {
        const result = await apiClient.user.getMe.query();
        if (result.status !== 200) throw result.body;
        return { ...result.body.data.user, declarant: result.body.data.declarant };
      } catch (error) {
        showErrorToast(error, 'Failed to fetch user details');
      }
    },
  });
};
